/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgFlagUk(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={18}
      fill='none'
      viewBox='0 0 24 18'
      {...props}
    >
      <path
        fill='#002781'
        d='M23 0H1a1 1 0 00-1 1v16a1 1 0 001 1h22a1 1 0 001-1V1a1 1 0 00-1-1z'
      />
      <path
        fill='#fff'
        d='M24 1a1 1 0 00-1-1h-2.58L14 4.938V0h-4v4.938L3.58 0H1a1 1 0 00-1 1v1.293L6.12 7H0v4h6.12L0 15.707V17a1 1 0 001 1h2.58L10 13.062V18h4v-4.938L20.42 18H23a1 1 0 001-1v-1.293L17.88 11H24V7h-6.12L24 2.293V1z'
      />
      <path fill='#D10D24' d='M24 8H13V0h-2v8H0v2h11v8h2v-8h11V8z' />
      <path
        fill='#D10D24'
        d='M23.5.154L14.6 7h1.64L24 1.031V1a.986.986 0 00-.5-.846zM16.24 11H14.6l8.9 6.846c.294-.174.5-.48.5-.846v-.031L16.24 11zM7.76 11L0 16.969V17c0 .366.206.672.5.846L9.4 11H7.76zM7.76 7H9.4L.5.154A.986.986 0 000 1v.031L7.76 7z'
      />
    </svg>
  );
}

export default SvgFlagUk;
